import React from "react";

import Navigation from "./../Navigation.js";
import Footer from "./../Footer.js";
import CopyProvider from "./../CopyProvider.js";
import SpecialMessage from "./SpecialMessage.js";
import Hero from "./Hero.js";
import SectionProduct from "./SectionProduct.js";
import SectionPOD from "./SectionPOD.js";
import SectionTutorial from "./SectionTutorial.js";
import SectionTestimonials from "./SectionTestimonials.js";
import SectionFAQ from "./SectionFAQ.js";

class Home extends React.Component {
  static locales = {
    en: "Home/en.js",
    de: "Home/de.js",
  };
  state = {
    w: window.innerWidth,
  };
  onResize = () => {
    this.setState({ w: window.innerWidth });
  };
  componentDidMount() {
    window.addEventListener("resize", this.onResize, { passive: true });
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize, { passive: true });
  }
  render() {
    const w = this.state.w;
    return (
      <React.Fragment>
        <Navigation w={w} />
        <CopyProvider
          locale={this.props.match.params.locale}
          locales={Home.locales}
        >
          <SpecialMessage {...this.props} w={w} />
          <Hero {...this.props} w={w} />
          <SectionProduct {...this.props} w={w} />
          <SectionPOD {...this.props} w={w} />
          <SectionTutorial {...this.props} />
          <SectionTestimonials {...this.props} w={w} />
          <SectionFAQ {...this.props} />
        </CopyProvider>
        <Footer />
      </React.Fragment>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home/Home.js